import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { browserHistory } from 'react-router';
import assign from 'object-assign';
import PropTypes from 'prop-types';

import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import DetailView from '../Common/DetailView';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { getISODateLimits } from '../../utils/Date';
import LocationIcon from 'material-ui/svg-icons/device/location-searching';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import EventDialogCreate from '../Event/EventDialogCreate';
import { statusColours } from '../../constants/ColourConstants';
import EventWrapper from '../Event/EventWrapper';
import EventDialog from '../Event/EventDialog';

import ErrorSnackbar from '../Common/ErrorSnackbar';

import buildContextMenu from '../Common/BuildContextMenu';
import EventActions from '../../actions/EventActionCreator';
import LocationActions from '../../actions/LocationActionCreator';
import LocationStore from '../../stores/LocationStore';
import LocationEventStore from '../../stores/LocationEventStore';

import ROLES from '../../constants/Roles';

BigCalendar.momentLocalizer(moment);

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const formats = {

};

class LocationCalendar extends Component {

    componentWillMount() {
        const locationId = Number(this.props.routeParams.id) || null;
        this.setState({
            locationId,
            actions: buildContextMenu(this.getActions(locationId)),
            dialog: {
                open: false,
                start: null,
                end: null,
                eventDates: null
            }
        });
    }

    componentDidMount() {
        this.onNavigate = this.onNavigate.bind(this);
        this.onDateSelect = this.onDateSelect.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.onEventFormSubmit = this.onEventFormSubmit.bind(this);
        this.onEventChange = this.onEventChange.bind(this);
        this.selectEvent = this.selectEvent.bind(this);
        this.convertEvent = this.convertEvent.bind(this);

        if (!!this.state.locationId) {
            LocationActions.getById(this.state.locationId);
            LocationActions.getEventList(this.state.locationId, getISODateLimits());
        }
        this.eventListener = LocationEventStore.addListener(this.onEventChange)
    }

    componentWillUnmount() {
        this.eventListener.remove();
    }

    render() {
        const { actions } = this.state;
        const scrollToTime = new Date();
        scrollToTime.setHours(6);

        return (
            <DetailView
                title=''
                backButton={true}
                actions={actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title="Calendar"
                            subtitle={(this.state.location && this.state.location.name) || 'Location'}
                            avatar={<CalendarIcon style={style.icon} color={statusColours.default}/>}
                        />
                        <CardText className="cent-card-calendar">
                            <BigCalendar
                                popup
                                popupOffset={20}
                                formats={formats}
                                views={['month', 'week', 'day']}
                                selectable={this.context.auth.isAdmin()}
                                defaultView="month"
                                events={this.state.events}
                                eventPropGetter={this.eventPropGetter}
                                onNavigate={this.onNavigate}
                                onSelectEvent={this.onSelectEvent}
                                onSelectSlot={this.onDateSelect}
                                components={{eventWrapper: EventWrapper}}
                                scrollToTime={scrollToTime}
                            />
                        </CardText>
                    </Card>
                </div>
                {this.state.dialog.open &&
                    <EventDialogCreate
                        title='Create new event'
                        open
                        eventDates={this.state.dialog.eventDates}
                        start={this.state.dialog.start}
                        end={this.state.dialog.end}
                        onClose={this.onDialogClose}
                        onSave={this.onEventFormSubmit}
                    />
                }
                <EventDialog
                    event={this.state.selectedEvent}
                    onClose={() => this.selectEvent()}
                    editLink={(ROLES.ADMIN && this.state.selectedEvent && `/dashboard/event/${this.state.selectedEvent.id}/edit`) || null}
                />
                <ErrorSnackbar/>
            </DetailView>
        );
    }

    getActions(id) {
        if (!id) { return []; }
        return [
            {
                link: `/dashboard/location/${id}`,
                icon: <LocationIcon />,
                label: 'Preview',
            }
        ];
    }

    onNavigate(date, view) {
        LocationActions.getEventList(this.state.locationId, getISODateLimits(date, view));
    }

    onSelectEvent({url}) {
        if (!!url) {
            browserHistory.push(url);
        }
    }

    eventPropGetter(event, startDate, endDate, selected) {
        let prop = {};
        const now = (new Date()).getTime();
        if (endDate.getTime() < now) {
            prop.className = 'cent-event-past';
        } else if (startDate.getTime() > now) {
            prop.className = 'cent-event';
        }
        return prop;
    }

    onDateSelect(slotInfo) {
        const options = {weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'};
        const startDate = slotInfo.start.toLocaleString('en-GB', options).substring(0,11);
        const endDate = slotInfo.end.toLocaleString('en-GB', options).substring(0,11);

        let dialog = {};
        dialog.start = slotInfo.start;
        dialog.end = slotInfo.end;
        dialog.eventDates = startDate;
        if (startDate !== endDate) {
            dialog.eventDates = `${dialog.eventDates} - ${endDate}`;
        }
        dialog.open = true;

        this.setState({dialog});
    }

    onDialogClose() {
        this.setState({dialog: assign({}, this.state.dialog, {open: false})});
    }

    onEventFormSubmit(data) {
        data.timeStart = data.timeStart.toString().replace(/\s\([^)]+\)/, '');
        data.timeEnd = data.timeEnd.toString().replace(/\s\([^)]+\)/, '');
        data.description = '';
        data.venueId = this.state.location.venueId;
        data.locationId = this.state.locationId;
        data.periodic = false;

        EventActions.save(data);

        LocationActions.getEventList(this.state.locationId, getISODateLimits());

        this.onDialogClose();
    }

    onEventChange() {
        const events = this.state.location && LocationEventStore.getByLocation(this.state.location.id);
        if (!!events) {
            this.setState({events: events.map(this.convertEvent)});
        }
    }

    convertEvent({id, name, ...event}) {
        const start = new Date(event.eventStart || event.timeStart);
        const end = new Date(event.eventEnd || event.timeEnd);
        return {
            id,
            title: name,
            start,
            end,
            allDay: (start.toLocaleTimeString() === "00:00:00" && end.toLocaleTimeString() === "00:00:00"),
            url:   `/dashboard/event/${id}`,
            selectAction: () => this.selectEvent(id)
        };
    }

    selectEvent(eventId) {
        this.setState({selectedEvent: (!!eventId && LocationEventStore.getById(eventId)) || null});
    }
}

LocationCalendar.getStores = () => ([LocationStore, LocationEventStore]);
LocationCalendar.calculateState = (prevState) => {
    const locationId = (prevState && prevState.locationId) || null;
    return {
        ...prevState,
        isFetching: LocationStore.isFetching() || LocationEventStore.isFetching(),
        location: !!locationId && LocationStore.getById(locationId),
        events: prevState && prevState.events || [],
    };
};
LocationCalendar.contextTypes = {
    auth:       PropTypes.object
};
export default Container.create(LocationCalendar);
